import { client } from "utils/api";

const getChannels = (q) =>
  new Promise(async (resolve, reject) => {
    try {
      const { data } = await client.get(
        `/channels?context=list${
          q ? `&q[identifier_matches]=%25${q}%25` : ""
        }`
      );
      const options = data.map(({ identifier, id }) => ({
        label: identifier,
        value: id,
      }));
      resolve(options);
    } catch (error) {
      console.log(error);
      reject([]);
    }
  });

export default getChannels;
